import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { Spacer, SpacerProps } from "../../layout";
import { labelStyles } from "./FormLabelLabel";

interface FormLabelFeedbackProps extends SpacerProps {
    themeMode: RequiredThemeKeys;
}

const shouldForwardPropToBaseComponent = (prop: string) => {
    switch (prop) {
        // Add any props that should NOT be forwarded to Base Component here.
        case "themeMode":
            return false;
        default:
            return true;
    }
};

export const FormLabelFeedback = styled(Spacer, {
    shouldForwardProp: shouldForwardPropToBaseComponent,
})<FormLabelFeedbackProps>`
    &:not(:empty) {
        margin-top: ${({ themeMode }) => labelStyles.margin(themeMode)}px;
    }
`;
